import { render, staticRenderFns } from "./Amortize.vue?vue&type=template&id=8adb612a&scoped=true&"
import script from "./Amortize.vue?vue&type=script&lang=js&"
export * from "./Amortize.vue?vue&type=script&lang=js&"
import style0 from "./Amortize.vue?vue&type=style&index=0&id=8adb612a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adb612a",
  null
  
)

export default component.exports